import axios from './defaultClient';

export const isLogined = async () => {
    return await axios.post('/jwt-auth/v1/token/validate');
}